import { useSyncExternalStore } from "react";

export const MOBILE_WEB_MAX_WIDTH = 480;
const MOBILE_WEB_QUERY = `(max-width: ${MOBILE_WEB_MAX_WIDTH}px)`;

let mediaQuery: MediaQueryList | null = null;
const subscribers = new Set<() => void>();

function getMediaQuery() {
  if (typeof window === "undefined" || !window.matchMedia) {
    return null;
  }

  mediaQuery ??= window.matchMedia(MOBILE_WEB_QUERY);
  return mediaQuery;
}

function notifySubscribers() {
  subscribers.forEach((subscriber) => subscriber());
}

function subscribe(subscriber: () => void) {
  const query = getMediaQuery();
  subscribers.add(subscriber);

  if (subscribers.size === 1) {
    query?.addEventListener("change", notifySubscribers);
  }

  return () => {
    subscribers.delete(subscriber);

    if (subscribers.size === 0) {
      query?.removeEventListener("change", notifySubscribers);
    }
  };
}

function getSnapshot() {
  return getMediaQuery()?.matches ?? false;
}

export function useIsMobileWeb() {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
